import Client from "../client/ApiClient"

// REACT_APP_API_DOMAIN đã gồm /api/v1 (vd: http://localhost:8000/api/v1)
const login = (data) => Client.post("authentications/login/", data)

const userRepository = {
  login
}
export default userRepository
